<template lang="pug">
  .categories
    .section
      .container.has-text-centered
        h1 {{ gettext('Job categories') }}
        p {{ gettext('For what position are you searching a candidate for?') }}
        .blocks-wrap
          .columns.is-multiline
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              router-link.img-wrap(:to="`/${getLanguage}/`")
                .img-bg
                img(src="@/assets/images/categories/1.png")
                span {{ gettext('Agriculture') }}
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              .img-wrap
                .img-bg
                img(src="@/assets/images/categories/2.png")
                span {{ gettext('Hospitality') }}
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              .img-wrap
                .img-bg
                img(src="@/assets/images/categories/3.png")
                span {{ gettext('Construction') }}
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              .img-wrap
                .img-bg
                img(src="@/assets/images/categories/4.png")
                span {{ gettext('Drivers') }}
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              .img-wrap
                .img-bg
                img(src="@/assets/images/categories/5.png")
                span {{ gettext('Industry') }}
            .column.is-one-mobile.is-half-tablet.is-one-third-desktop
              .img-wrap
                .img-bg
                img(src="@/assets/images/categories/6.png")
                span {{ gettext('Care') }}
</template>

<script>
import {mapGetters} from 'vuex'
import {gettext} from './../../services/TranslateHandler'
import mixin from '@/mixins'

export default {
  name: 'Categories',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Categories'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/categories/index.vue